import React from 'react'
import Image from '@boltui/image'

import styles from './AppPrompt.scss'

const appLink = {
  IOS_APP_DOWNLOAD: 'https://apps.apple.com/gb/app/argos/id370371087',
  GOOGLE_APP_DOWNLOAD: 'https://play.google.com/store/apps/details?id=com.homeretailgroup.argos.android&hl=en_GB',
}

const AppPrompt = () => (
  <div className='container'>
    <div className={styles['app-prompt']}>
      <Image
        src={'https://media.4rgos.it/i/Argos/app-argos-prompt?h=38&w=28&qlt=50'}
        className={styles['app-prompt-logo']}
        data-test={'image-argos-card'}
        alt='Argos App Logo'
        responsive
        lazy
      />

      <div className={styles['app-prompt-text']}>
        <h4>Argos in the palm of your hand</h4>
        <p>Tap our free app and start exploring</p>
      </div>

      <div className={styles['app-prompt-links']}>
        <a href={appLink.IOS_APP_DOWNLOAD} data-test='link-app-iphone' target='_blank'>
          <Image
            width={135}
            qlt={80}
            data-test={'image-apple-app-store'}
            className={styles['app-prompt-apple-app-store']}
            src='https://media.4rgos.it/i/Argos/app-apple-prompt'
            alt='Download on the Apple App Store'
            lazy
          />
        </a>
        <a href={appLink.GOOGLE_APP_DOWNLOAD} data-test='link-app-android' target='_blank'>
          <Image
            width={135}
            qlt={80}
            data-test={'image-google-play-store'}
            className={styles['app-prompt-google-play-store']}
            src='https://media.4rgos.it/i/Argos/app-google-prompt'
            alt='Download on the Google Play Store'
            lazy
          />
        </a>
      </div>
    </div>
  </div>
)

export default AppPrompt
